import { useLanguage } from "@/contexts/LanguageContext";

const copy = {
  pt: {
    eyebrow: "QUIMICAL EM NÚMEROS",
    title: "Experiência consolidada no fornecimento de cal industrial.",
    items: [
      { value: "+400", label: "clientes ativos" },
      { value: "+4.000", label: "entregas concluídas" },
      { value: "+500 mil t", label: "comercializadas" },
      { value: "Sul + Sudeste", label: "forte presença regional" },
    ],
  },
  en: {
    eyebrow: "QUIMICAL IN NUMBERS",
    title: "Consolidated experience in industrial lime supply.",
    items: [
      { value: "400+", label: "active customers" },
      { value: "4,000+", label: "completed deliveries" },
      { value: "500k+ t", label: "commercialized" },
      { value: "South + Southeast", label: "strong regional presence" },
    ],
  },
  es: {
    eyebrow: "QUIMICAL EN NÚMEROS",
    title: "Experiencia consolidada en el suministro de cal industrial.",
    items: [
      { value: "+400", label: "clientes activos" },
      { value: "+4.000", label: "entregas concluidas" },
      { value: "+500 mil t", label: "comercializadas" },
      { value: "Sur + Sudeste", label: "fuerte presencia regional" },
    ],
  },
} as const;

const TrustNumbers = () => {
  const { language } = useLanguage();
  const c = copy[language];

  return (
    <section aria-labelledby="trust-numbers-title" className="border-t border-slate-200 bg-slate-50 py-20 md:py-24">
      <div className="container mx-auto max-w-6xl px-4">
        <div className="max-w-2xl">
          <p className="text-xs font-semibold tracking-[0.22em] text-primary">{c.eyebrow}</p>
          <h2 id="trust-numbers-title" className="mt-4 text-3xl font-semibold tracking-[-0.03em] text-slate-950 md:text-4xl">
            {c.title}
          </h2>
        </div>

        <div className="mt-12 grid gap-px overflow-hidden rounded-3xl border border-slate-200 bg-slate-200 sm:grid-cols-2 lg:grid-cols-4">
          {c.items.map((item) => (
            <div key={item.label} className="bg-white p-7 md:p-8">
              <div className="text-3xl font-semibold tracking-[-0.04em] text-slate-950 md:text-4xl">{item.value}</div>
              <p className="mt-3 text-sm leading-relaxed text-slate-600">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustNumbers;
